import { render, staticRenderFns } from "./AffiliatesStatList.vue?vue&type=template&id=45489e50&"
import script from "./AffiliatesStatList.vue?vue&type=script&lang=js&"
export * from "./AffiliatesStatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports